<p-panel [header]="'my_orders' | translate">
<app-loader *ngIf="!isDataReady"></app-loader>
<div class="ui-g" *ngIf="isDataReady">
    <div *ngIf="myOrders.length == 0" class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">

            <div style="display: flex;justify-content: center;">
                {{'orders_empty_orders' | translate}}<br/><br/>
            </div>


        </div>
    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
        <p-panel [class]="'nuty-border'" [style]="{'color':'#333333', 'background-color':'#f4f4f4', 'margin-bottom': '20px'}"
            *ngFor="let order of myOrders">
            <p-header>
                <div class="ui-helper-clearfix">
                    <div class="order">

                        <div>
                            <span class="ui-panel-title">
                                {{ 'order_no' | translate }}: {{ order.id }}
                            </span>
                        </div>

                        <div class="orderHeader">
                            <p-progressSpinner *ngIf="paymentInProgress && !order.is_paid" [style]="{width: '35px', height: '35px'}">
                            </p-progressSpinner>
                            <button (click)="onDownloadAvailableInvoice(order)" *ngIf="hasAvailableInvoice(order)" mat-button color="primary"> <i
                                    class="pi pi-file-pdf " style="font-size: 1.8em"></i>
                                {{'download_invoice' | translate}} </button>
                            <button [disabled]="order.isPayInProgress" (click)="onCreatePayment(order)"
                                *ngIf="!order.is_paid && !paymentInProgress" mat-button color="primary">
                                <p-progressSpinner *ngIf="order.isPayInProgress" [style]="{width: '15px', height: '15px'}">
                                </p-progressSpinner>
                                <i *ngIf="!order.isPayInProgress" class="pi pi-replay" style="font-size: 1.8em"></i>
                                {{'order_pay_order' | translate}}
                            </button>

                        </div>

                    </div>

                </div>
            </p-header>
            <div *ngFor="let note of order.items; index as i">
                <div>

                    <div class="p-grid">
                        <div class="orderItem p-col-12 p-sm-5 p-md-6 p-lg-6 p-xl-6">
                            <span *ngIf="!order.is_paid" class="orderItemTitle">{{ i+1 }}. {{ note.title }}</span>
                            <a *ngIf="order.is_paid" routerLink="/note/{{note.note_id}}/{{note.slug}}" class="orderItemTitle blueColorHover">{{ i+1 }}. {{ note.title }}</a>
                        </div>
                        <div class="orderItem p-col-4 p-sm-3 p-md-3 p-lg-3 p-xl-3">
                            {{ note.price | currencyReduce:true:order.currency_histories.exchange_rate | currency:order.currency_histories.currency.currency_code }}
                        </div>
                        <div class="orderItem orderItemOptions p-col-8 p-md-3 p-sm-4 p-lg-3 p-xl-3">
                            <button *ngIf="order.is_paid" [disabled]="note.isDownloading" mat-button color="primary" (click)="onDownloadFile(note)">
                                <p-progressSpinner *ngIf="note.isDownloading" [style]="{width: '15px', height: '15px'}">
                                </p-progressSpinner>

                                <i *ngIf="!note.isDownloading" class="pi pi-download"></i>
                                {{'myorders_getNote' | translate}}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="orderFooterLine"></div>
            <div class="p-grid">
                <div class="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-12">
                    <div style="display: flex;justify-content: space-between;">
                        <span>{{ 'order_date' | translate }}: {{ order.created_at | date:'dd.MM.yyyy, HH:mm' }}</span>
                        <span>
                            <!--<span>{{order.payment_type}}</span>-->
                            {{ 'total' | translate }}:
                            {{ order.items | orderTotal | currencyReduce:true:order.currency_histories?.exchange_rate | currency:order.currency_histories?.currency_code }}</span>
                    </div>
                </div>
            </div>
        </p-panel>
    </div>
</div>

<p-paginator [rows]="this.limit" *ngIf="this.myOrders.length > 0"  [totalRecords]="this.totalRows" (onPageChange)="onPaginate($event)"></p-paginator>
</p-panel>
<p-dialog header="{{'paymanet_standard' | translate}}" *ngIf="bankInfo" [(visible)]="displayBankTransferInfo" [style]="{width: '50vw'}">
    <div [innerHTML]="this.infoBank"></div>
</p-dialog>
